import styled from "styled-components";

export const SubmeterPlanilhaStyle = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  background-color: #fff;
  width: 80%;
  border-radius: 10px;
  padding: 30px;

  .batch-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .batch-container-title {
    font-size: 3rem;
    text-align: center;
    color: #340040;
    margin-bottom: 25px;
    width: fit-content;
  }

  .upload-container {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    justify-content: center;
    align-items: center;
  }

  .upload-button {
    background: linear-gradient(267deg, rgb(131, 43, 146) 39%, rgb(160, 69, 176) 100%);
    border: none;
    color: white;
    font-weight: 600;
    letter-spacing: 0.2px;
    width: 120px;
  }
  .upload-button:hover {
    opacity: 0.8;
  }

  .file-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: fit-content;
  }

  .status-message {
    font-weight: 500;
  }

  .status-success {
    color: #2fa562ff;
  }

  .status-error {
    color: #d93025;
  }

  .message-group {
    display: flex;
    flex-direction: column;
  }
`;
